import { Card } from '../components/Card/Card';
import MultiFactorAuthenticationContainer from '../components/TwoFactorAuthentication/MultiFactorAuthenticationContainer';
import PageHeader from '../components/PageHeader/PageHeader';
import React from 'react';
import { Trans } from 'react-i18next';
import { auth } from '../utils';
import { paths } from '../constants/index';

const Security = () => (
  <div className="jg-background--white jg-bd@lg jg-bd--very-light-grey jg-space-pblg@lg">
    <div className="jg-space-psm jg-space-pllg@lg jg-space-ptlg@lg">
      <PageHeader>
        <h1 className="qa-page__heading">
          <Trans i18nKey="security.title">Security</Trans>
        </h1>
      </PageHeader>
    </div>

    <Card to={paths.Password}>
      <p className="jg-color--empress jg-text--medium-regular">
        <Trans i18nKey="tpasswordForm.changePassword">Change Password</Trans>
      </p>
    </Card>
    {auth.isCharity() ? null : (
      <Card to={paths.SecurityMfa}>
        <MultiFactorAuthenticationContainer security />
      </Card>
    )}
  </div>
);

export default Security;
